import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidAccountNumberWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.bank-account.validation.account-number.incorrect');
    }
}
